import React from 'react';
import { useTranslate } from '../../../lib';
import ButtonYesNo from '../../common/ButtonYesNo';
import { InputNesting } from '../../common/Inputs/Input';
import { TextareaNesting } from '../../common/Inputs/Input';

export default function SimulationSettings({
  showSimulationSetting,
  setShowSimulationSetting,
  simulationStatus,
  onChangeStatusSimulation,
  url_simulationRef,
  Simulation_Step_number_ref,
  assistedSimulation,
  setAssistedSimulation,
  BoxInfo,
}) {
  const { t } = useTranslate();

  return (
    <>
      {/* ENCABEZADO */}
      <div
        className='d-flex flex-row align-items-center justify-content-between w-100 mt-1 shadow_box'
        style={{
          backgroundColor: '#0088ff09',
          padding: 10,
          borderRadius: '10px 10px 0 0',
        }}
      >
        <div className='d-flex flex-row align-items-center w-100'>
          <div
            className='w-100'
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h2 onClick={() => setShowSimulationSetting(!showSimulationSetting)} style={{ color: '#0B5FA3', fontSize: 15, cursor: "pointer" }} className='m-0'>
              {t('menu.genai.simulationSettings')}
            </h2>

            {/* Botón Mostrar */}
            <button
              id='arrow-down-btn'
              style={{ display: !showSimulationSetting ? 'block' : 'none' }}
              className='ml-3'
              type='button'
              onClick={() => setShowSimulationSetting(true)}
            >
              <img src='/icons/arrow_down.png' alt='' style={{ width: 15 }} />
            </button>

            {/* Botón Ocultar */}
            <button
              id='arrow-down-btn'
              style={{ display: showSimulationSetting ? 'block' : 'none' }}
              className='ml-3'
              type='button'
              onClick={() => setShowSimulationSetting(false)}
            >
              <img src='/icons/arrow_up.png' alt='' style={{ width: 15 }} />
            </button>
          </div>
        </div>
      </div>

      {/* CONTENIDO DESPLEGABLE */}
      <div
        style={{
          display: showSimulationSetting ? 'flex' : 'none',
          backgroundColor: '#0088ff09',
          padding: '5px 10px 10px 10px',
        }}
        className='flex-column w-100 pt-3'
      >
        {/* TOGGLE Activar Simulación */}
        <div className="inputs" style={{ marginTop: 10 }}>
          <div className="input">
            <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>

              <BoxInfo
                id="ramvoice-tp"
                titleClass='mr-0-4'
                title={t('menu.genai.simulationStatus')}
                place="top"
                containerClass='mr-0-5 '
                content={t('menu.genai.simulationStatusTooltip')}
              />
              <ButtonYesNo
                onClick={() => onChangeStatusSimulation()}
                width={150}
                state={simulationStatus === 0 || simulationStatus === null ? false : simulationStatus}
                height={30}
                Yes={t('common.yes')}
                No={t('common.no')}
              />
            </div>
          </div>
        </div>

        {simulationStatus && (
          <>
            {/* URL de simulación */}
            <div className='mt-2'>
              <label style={{ fontSize: 14, fontWeight: 700 }}>
                {t('menu.genai.urlSimulation')}
              </label>
              <InputNesting
                type='text'
                containerClass='mt-1'
                placeholder='https://...'
                ref={url_simulationRef}
              />
            </div>

            {/* Número de pasos */}
            <div className='mt-2 d-flex flex-column' style={{width: '220px'}}>
              <label style={{ fontSize: 14, fontWeight: 700 }}>
                {t('menu.genai.simulationStepNumber')}
              </label>
              <InputNesting
                type='number'
                min='1'
                containerClass='mt-1'
                ref={Simulation_Step_number_ref}
              />
            </div>

            {/* Assisted simulation */}
            <div className="inputs" style={{ marginTop: 20 }}>
              <div className="input">
                <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>

                  <BoxInfo
                    id="Assisted-Simulation-tp"
                    titleClass='mr-0-4'
                    title={`${t('menu.genai.assistedSimulation')}:`}
                    place="top"
                    containerClass='mr-0-5 '
                    content={t('menu.genai.assistedSimulationTooltip')}
                  />
                  <ButtonYesNo
                    onClick={() => setAssistedSimulation((prev) => prev === 0 ? 1 : 0)}
                    width={150}
                    state={assistedSimulation === 0 || simulationStatus === null ? false : true}
                    height={30}
                    Yes={t('common.yes')}
                    No={t('common.no')}
                    disabled={!simulationStatus}
                  />
                </div>
              </div>
            </div>

          </>
        )}
      </div>
    </>
  );
}
